import { render, staticRenderFns } from "./ControlSectionOrControl.vue?vue&type=template&id=7f42ec56&"
import script from "./ControlSectionOrControl.vue?vue&type=script&lang=ts&"
export * from "./ControlSectionOrControl.vue?vue&type=script&lang=ts&"
import style0 from "./ControlSectionOrControl.vue?vue&type=style&index=0&id=7f42ec56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports